import { useEffect, useState } from "react";

// import { CallPopUpAgentActions } from "../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../services/call_service";
import { ChatActions } from "../../../store/slices/chat_slice/chat_slice";
import { ChatState } from "../../../base/models/model";
// import { Cookie } from "unifiedring-sdk/dist/base/config";
import { WtButton } from "../../../shared/widges/Button/button";
import _ from "lodash";
import callChatService from "../../../base/service/chatService";
import { newEmailEntriesSliceActions } from "../../../store/slices/new_emailEntries/newEmailEntries";
import store from "../../../store/redux-store/root_store";
import styles from "./incomingEmail.module.scss";
import { useDispatcher } from "../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import userImg from "../../../styles/images/person34.svg";


function IncomingEmailNotify() {
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  const [over, setOver] = useState(false);
  const [[m, s], setTime] = useState<any>([0, 30]);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);

  const newEmailEntries: any = useSelector((state: any) => state.newEntryEmailData.checkEmailArray);

  let { callSessionDetailswhilePopup } = popUpDetails;

  let { acceptCallFunction, declineCallFunction } = CallService(dispatch, navigate);
  const roomData: any = store.getState().chatReducer;
  let { allIncomingSessionDetails } = roomData;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);

  let { internalSessionId } = chatReducer;
  let { currentSession } = chatReducer;


  const acceptNotify = () => {


    callChatService.io.emit("acceptEmailNotify", { newEmailEntries })
    navigate('/chatscreenagent')
    dispatch(newEmailEntriesSliceActions.checkNewEmail({ isNewEmailEntry: false }))


  };

  const declineNotify = () => {
    setOver(true);
    let declineData = {
      to: internalSessionId.trim(),
      responseMessage: "chat is declined"

    };
    callChatService.agentDeclineRequest(declineData);
    callChatService.io.emit("agentDeclineRequest", { message: "Chat is declined", to: currentSession?.sessionId });
    dispatch(ChatActions.declineChat());

    // declineCallFunction(callSessionDetailswhilePopup.userAgent);
    // CallPopUpAgentActions.setWholeData({
    //   acceptCallRoom: false,
    //   callRoomInfo: "",
    //   callSessionId: "",
    //   callSessionDetailswhilePopup: "",
    //   isCallAccepted: false,
    // });
  };



  useEffect(() => {
    const timerID = setInterval(() => tick(), 1000);
    const ringer: any = document.getElementById("ringer");
    if (over) {
      ringer.pause();
      clearInterval(timerID);
      // dispatch(CallPopUpAgentActions.NotAttendedCall())
    }
    return () => {
      clearInterval(timerID);
    };
  }, [m, s, over]);

  const tick = () => {
    if (m === 0 && s === 0) {
      let declineData = {
        to: internalSessionId.trim(),
        responseMessage: "chat is declined",
      };
      callChatService.agentDeclineRequest(declineData);
      setOver(true);
    } else {
      setTime([m, s - 1]);
    }
  };

  useEffect(()=>{
    localStorage.removeItem("transfer_call");
  },[]);

  return (
    <>
      <div className={`${styles.callcontainartopsec}`}>
        <div className={styles.callwhisperinnercon}>
          <div className={styles.succesconsec}>
            <div className={styles.calliconsec}>
              <img src={userImg} alt="" className={styles.userImage} />
              <h4>Email</h4>
            </div>
            <div className={styles.userconsec}>
              <span>{!_.isEmpty(allIncomingSessionDetails) ? allIncomingSessionDetails.customerData : "New Customer"}</span>
              <label className={styles.phnenumber}>{allIncomingSessionDetails.customerData}</label>
            </div>
            <div className={styles.supportconsec}>
              <span className={styles.curntsuprt}>Customer Support</span>
              <label className={styles.anstxt}>
                Accept in{" "}
                <span className={styles.timecount}>
                  <p>{`${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`}</p>
                </span>
              </label>
            </div>
            <div className={styles.acceptbtnconsec}>
              <WtButton className={`buttonGreen ${styles.declinebtn}`} onClick={declineNotify} name="Decline" />
              <WtButton className={`buttonGreen ${styles.acceptbtn}`} onClick={acceptNotify} name="Accept" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default IncomingEmailNotify;
